import SettingsListView2 from 'src/views/settings/SettingsListView2';

export default function Settings() {
    return <SettingsListView2 />;
}
